"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadAssets = exports.spriteMapSources = void 0;
var largeSprites_1 = require("@sprites/largeSprites");
var imports_1 = require("../lib/imports");
exports.spriteMapSources = [
    '',
    'ssp0',
    'ssp1',
    'ssp2',
    'ssp3',
    'ssp4',
];
// export const backgroundImages = ['under/x/under-background']
function preloadAssets(load) {
    // this.load.glsl("bundle", "assets/plasma-bundle.glsl.js");
    // this.load.glsl("stars", "assets/starfields.glsl.js");
    loadImgs(load, exports.spriteMapSources);
    // TODO: per-project?
    // loadImgs(load, backgroundImages)
    // loadImgs(load, ['1-32'])
    // loadImgs(load, ['monsters'])
    // loadImgs(load, ['dungeon'])
    // loadImgs(load, ['ui'])
    // loadImgs(load, ['ship'])
    // loadImgs(load, ['6-15'])
    // loadImgs(load, ['7-16'])
    // loadImgs(load, ['8-8'])
    // loadImgs(load, ['9-Items'])
    loadSoundSprites(load, ['audioSprite2']);
    // loadJson(load, ['voyage'], 'assets/data')
    // loadJson(load, ['player-walk-arms-split'], 'assets/sprites/under/player')
    // loadTxt(load, ['books'], 'assets/data')
    // loadStevieFonts(load, ['oryx_32px', 'oryx_24px', 'oryx_16px'])
    loadTxt(load, ['minigolf-regions'], 'assets/data');
    loadLargeSprites(load);
}
exports.preloadAssets = preloadAssets;
function loadLargeSprites(load) {
    imports_1.l.forEach(largeSprites_1.largeSprites, function (c) {
        load.image(c.k, "assets/sprites/" + (c.d + '/' + c.f) + ".png");
    });
}
function loadImgs(load, names) {
    names.forEach(function (c) {
        if (c) {
            load.image(c, "assets/sprites/" + c + ".png");
        }
    });
}
function loadSoundSprites(load, names) {
    loadJson(load, names, 'assets/sounds');
}
function loadJson(load, names, path) {
    names.forEach(function (c) {
        load.json(c, path + "/" + c + ".json");
    });
}
function loadTxt(load, names, path) {
    // console.log('text is loading!')
    names.forEach(function (c) {
        console.log('preloading text:' + c);
        load.text(c, path + "/" + c + ".txt");
    });
}
// function loadStevieFonts(load: Phaser.Loader.LoaderPlugin, names: string[]) {
//   names.forEach((c) => {
//     load.json(c + '-font-data', `assets/fonts/${c}.json`)
//     load.image(c + '-font', `assets/fonts/${c}.png`)
//   })
// }
